const config = {
  header: "Header",
  headerBackground: "#ff8ba7",
  bodyBackground: "#ffc6c7",
  title: "Coffee with Sesame",
  subTitle: "Member Hub",
  airtable: "https://airtable.com/embed/shrDHQN6QyBxrcfTu?backgroundColor=red&viewControls=on",
  googleAnalytics: "UA-XXXXXXXX-X"
}

export default config
